import React, { Component } from "react";
import {
  Checkbox,
  Input,
  message,
  Select,
  PageHeader,
  Col,
  Row,
  Spin,
  Divider,
} from "antd";
import axios from "axios";
import { connect } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  cuentaMask,
  InputItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import AgregarTipoDePoliza from "../../TiposDePolizas/AgregarTipoDePoliza/AgregarTipoDePoliza";
import AgregarTipoDeFlujo from "../../TiposDeFlujos/AgregarTipoDeFlujo/AgregarTipoDeFlujo";

const { Option } = Select;

class EditarTipoDeProveedor extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    todasCuentaContable: null,
    objetoCuentaContable: null,
    todasCuentasContablesFinales: null,
    objetoCuentasContablesFinales: null,
    todasTiposDePolizas: null,
    objetoTiposDePolizasDiario: null,
    objetoTiposDePolizasEgreso: null,
    todasTiposDeFlujos: null,
    objetoTiposDeFlujos: null,
    modalAgregarCuentaContable: false,
    modalAgregarTipoDePoliza: false,
    id: this.props.location.state.id,
  };
  atras() {
    this.props.history.goBack();
  }
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "tiposdepolizas/selectTiposDePolizas",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasTiposDePolizas: res.data });
          this.setState({
            objetoTiposDePolizasDiario: res.data.map((value) => {
              if (value.tipoDePolizaId === 1 || value.tipoDePolizaId === 2) {
                return null;
              }
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.descripcion}
                </Option>
              );
            }),
          });
          this.setState({
            objetoTiposDePolizasEgreso: res.data.map((value) => {
              if (value.tipoDePolizaId !== 2) {
                return null;
              }
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "tiposdeflujos/selectTiposDeFlujos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasTiposDeFlujos: res.data });
          this.setState({
            objetoTiposDeFlujos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    let generarCuentasAutomatico = false
    await axios
      .post(
        "tiposdeproveedores/datosTipoDeProveedor",
        { empresaId: this.props.empresaId, tipoDeProveedorId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion del tipo de proveedor");
        } else {
          if (res.data.utilizado) {
            message.info('No se puede modificar toda la informacion ya que el tipo de proveedor ya fue utilizado')
          }
          this.formRef.current.setFieldsValue({
            ...res.data,
          });
          generarCuentasAutomatico = res.data.generarCuentasAutomatico
          this.setState({
            utilizado: res.data.utilizado,
          })
        }
      });
    if (generarCuentasAutomatico) {
      await axios
        .post(
          "cuentascontables/selectCuentasContablesSinNivel5",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasCuentaContable: res.data });
            this.setState({
              objetoCuentaContable: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {cuentaMask(
                      value.nivel1 +
                      value.nivel2 +
                      value.nivel3 +
                      value.nivel4 +
                      value.nivel5
                    ) +
                      " - " +
                      value.descripcion}
                  </Option>
                );
              }),
            });
          }
        });
    } else {
      await axios
        .post(
          "cuentascontables/selectCuentasContablesFinalesSinNivel5",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasCuentaContable: res.data });
            this.setState({
              objetoCuentaContable: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {cuentaMask(
                      value.nivel1 +
                      value.nivel2 +
                      value.nivel3 +
                      value.nivel4 +
                      value.nivel5
                    ) +
                      " - " +
                      value.descripcion}
                  </Option>
                );
              }),
            });
          }
        });
    }
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposdeproveedores/editarTipoDeProveedor",
        { ...values, empresaId: this.props.empresaId, tipoDeProveedorId: this.state.id },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se edito un tipo de proveedor");
          this.formRef.current.resetFields();
          this.atras(res.data.id);
        } else {
          message.error("Sucedio un error y no se edito");
        }
      });
  }

  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo().then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ cuentaContableId: codigo });
      }
    });
  }
  abrirAgregarTipoDePoliza() {
    this.setState({ modalAgregarTipoDePoliza: true });
  }
  cerrarAgregarTipoDePoliza(codigo) {
    this.setState({ modalAgregarTipoDePoliza: false });
    this.consultarTodo();
  }
  abrirAgregarTipoDeFlujo() {
    this.setState({ modalAgregarTipoDeFlujo: true });
  }
  cerrarAgregarTipoDeFlujo(codigo) {
    this.setState({ modalAgregarTipoDeFlujo: false });
    this.consultarTodo().then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ tipoDeFlujoId: codigo });
      }
    });;
  }
  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Editar Tipo de Proveedor"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="editarProveedor"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Guardar Tipo de Proveedor
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row>
                <Col span={12}>
                  <FormItem
                    label="Nombre"
                    margin
                    pattern
                    required
                    max={20}
                    name="nombre"
                  >
                    <InputItem placeholder="Nombre" />
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem
                    label="Descripcion"
                    margin
                    pattern
                    required
                    max={200}
                    name="descripcion"
                  >
                    <InputItem placeholder="Descripcion" />
                  </FormItem>
                </Col>
              </Row>
              <Divider style={{ marginBottom: 10, marginTop: 5 }} />
              <Row>
                <Col span={12}>
                  <Row>
                    <Col span={12}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            <FormItem
                              label="Consecutivo de cuentas"
                              margin
                              numberCero
                              required={getFieldValue("generarCuentasAutomatico")}
                              name="consecutivoCuentas"
                              labelCol={{ span: 12 }}
                              wrapperCol={{ span: 12 }}
                            >
                              <InputNumberItem
                                disabled={
                                  !getFieldValue("generarCuentasAutomatico")
                                }
                                placeholder="Consecutivo de cuentas"
                              />
                            </FormItem>
                          );
                        }}
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        name="generarCuentasAutomatico"
                        label="Generar Cuentas en automatico"
                        valuePropName="checked"
                        initialValue={false}
                        margin
                        labelCol={{ span: 18 }}
                        wrapperCol={{ span: 6 }}
                      >
                        <Checkbox disabled={this.state.utilizado} />
                      </FormItem>
                    </Col>
                  </Row>
                  <FormItem
                    label="Cuenta Proveedor"
                    margin
                    shouldUpdate
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input.Group compact>
                      <FormItem
                        name="cuentaProveedorId"
                        required
                        noStyle
                      >
                        <SelectItem
                          disabled={this.state.utilizado}
                          placeholder="Cuenta Proveedor"
                          width="80%"
                        >
                          {this.state.objetoCuentaContable}
                        </SelectItem>
                      </FormItem>
                      <ButtonItem
                        blanco
                        icon={<PlusOutlined />}
                        style={{ width: "20%" }}
                        onClick={this.abrirAgregarCuentaContable.bind(this)}
                      />
                    </Input.Group>
                  </FormItem>
                  <FormItem
                    label="Cuenta Anticipo"
                    margin
                    shouldUpdate
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input.Group compact>
                      <FormItem
                        name="cuentaAnticipoId"
                        required
                        noStyle
                      >
                        <SelectItem
                          disabled={this.state.utilizado}
                          placeholder="Cuenta Anticipo"
                          width="80%"
                        >
                          {this.state.objetoCuentaContable}
                        </SelectItem>
                      </FormItem>
                      <ButtonItem
                        blanco
                        icon={<PlusOutlined />}
                        style={{ width: "20%" }}
                        onClick={this.abrirAgregarCuentaContable.bind(this)}
                      />
                    </Input.Group>
                  </FormItem>
                  <FormItem
                    label="Cuenta Fon. Gar."
                    margin
                    shouldUpdate
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input.Group compact>
                      <FormItem
                        name="cuentaFonGarId"
                        required
                        noStyle
                      >
                        <SelectItem
                          disabled={this.state.utilizado}
                          placeholder="Cuenta Fondo de Gararantia"
                          width="80%"
                        >
                          {this.state.objetoCuentaContable}
                        </SelectItem>
                      </FormItem>
                      <ButtonItem
                        blanco
                        icon={<PlusOutlined />}
                        style={{ width: "20%" }}
                        onClick={this.abrirAgregarCuentaContable.bind(this)}
                      />
                    </Input.Group>
                  </FormItem>
                  <FormItem
                    label="Cuenta Deudor"
                    margin
                    shouldUpdate
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input.Group compact>
                      <FormItem
                        name="cuentaDeudorId"
                        required
                        noStyle
                      >
                        <SelectItem
                          disabled={this.state.utilizado}
                          placeholder="Cuenta Deudor"
                          width="80%"
                        >
                          {this.state.objetoCuentaContable}
                        </SelectItem>
                      </FormItem>
                      <ButtonItem
                        blanco
                        icon={<PlusOutlined />}
                        style={{ width: "20%" }}
                        onClick={this.abrirAgregarCuentaContable.bind(this)}
                      />
                    </Input.Group>
                  </FormItem>
                  <FormItem
                    label="Cuenta Impagable"
                    margin
                    shouldUpdate
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input.Group compact>
                      <FormItem
                        name="cuentaImpagableId"
                        noStyle
                      >
                        <SelectItem
                          placeholder="Cuenta Impagable"
                          width="80%"
                        >
                          {this.state.objetoCuentaContable}
                        </SelectItem>
                      </FormItem>
                      <ButtonItem
                        blanco
                        icon={<PlusOutlined />}
                        style={{ width: "20%" }}
                        onClick={this.abrirAgregarCuentaContable.bind(this)}
                      />
                    </Input.Group>
                  </FormItem>
                  <FormItem label="Cuenta Ajuste Centavos"
                    margin
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    shouldUpdate
                  >
                    <Input.Group compact>
                      <FormItem name="cuentaAjusteCentavosId" noStyle>
                        <SelectItem placeholder="Cuenta Ajuste Centavos" width="90%">
                          {this.state.objetoCuentaContable}
                        </SelectItem>
                      </FormItem>
                      <ButtonItem
                        icon={<PlusOutlined />}
                        style={{ width: "10%" }}
                        onClick={this.abrirAgregarCuentaContable.bind(this)}
                      />
                    </Input.Group>
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem
                    label="Tipo de Poliza Diario"
                    margin
                    tooltip="Elegir polizas de diario solamente"
                  >
                    <Input.Group compact>
                      <FormItem name="tipoDePolizaDiarioId" required noStyle>
                        <SelectItem
                          placeholder="Tipo de Poliza Diario"
                          width="80%"
                        >
                          {this.state.objetoTiposDePolizasDiario}
                        </SelectItem>
                      </FormItem>
                      <ButtonItem
                        blanco
                        icon={<PlusOutlined />}
                        style={{ width: "20%" }}
                        onClick={this.abrirAgregarTipoDePoliza.bind(this)}
                      />
                    </Input.Group>
                  </FormItem>
                  <FormItem
                    label="Tipo de Poliza Egreso"
                    margin
                    tooltip="Elegir polizas de egreso solamente"
                  >
                    <Input.Group compact>
                      <FormItem name="tipoDePolizaEgresoId" required noStyle>
                        <SelectItem
                          placeholder="Tipo de Poliza Egreso"
                          width="80%"
                        >
                          {this.state.objetoTiposDePolizasEgreso}
                        </SelectItem>
                      </FormItem>
                      <ButtonItem
                        blanco
                        icon={<PlusOutlined />}
                        style={{ width: "20%" }}
                        onClick={this.abrirAgregarTipoDePoliza.bind(this)}
                      />
                    </Input.Group>
                  </FormItem>
                  <FormItem
                    label="Tipo de Flujo"
                    margin
                    tooltip="El tipo de flujo sirve para saber si se generara el diot y si es un ingreso"
                  >
                    <Input.Group compact>
                      <FormItem name="tipoDeFlujoId" required noStyle>
                        <SelectItem placeholder="Tipo de Flujo" width="80%">
                          {this.state.objetoTiposDeFlujos}
                        </SelectItem>
                      </FormItem>
                      <ButtonItem
                        blanco
                        icon={<PlusOutlined />}
                        style={{ width: "20%" }}
                        onClick={this.abrirAgregarTipoDeFlujo.bind(this)}
                      />
                    </Input.Group>
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </Spin>
        </div>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
            this
          )}
        />
        <AgregarTipoDePoliza
          visible={this.state.modalAgregarTipoDePoliza}
          cerrarAgregarTipoDePoliza={this.cerrarAgregarTipoDePoliza.bind(this)}
        />
        <AgregarTipoDeFlujo
          visible={this.state.modalAgregarTipoDeFlujo}
          cerrarAgregarTipoDeFlujo={this.cerrarAgregarTipoDeFlujo.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EditarTipoDeProveedor);
